import { BOOLEAN, NUMBER, NUMBER_CSV, STRING, STRING_CSV } from './utils';
import { getFrontendConfigOverride } from './frontend-config-overrides';
import { maybe } from 'true-myth';

export const getNumberConfig = (name: string, defaultVal: number) =>
  getFrontendConfigOverride('Number', name) ??
  NUMBER()
    .andThen((number) => maybe.of(number[name]))
    .unwrapOr(defaultVal);

export const getStringConfig = (name: string, defaultVal: string) =>
  getFrontendConfigOverride('String', name) ??
  STRING()
    .andThen((string) => maybe.of(string[name]))
    .unwrapOr(defaultVal);

export const getBooleanConfig = (name: string, defaultVal: boolean) =>
  getFrontendConfigOverride('Boolean', name) ??
  BOOLEAN()
    .andThen((boolean) => maybe.of(boolean[name]))
    .unwrapOr(defaultVal);

export const getStringListConfig = (name: string, defaultVal: Array<string>) =>
  getFrontendConfigOverride('StringCsv', name) ??
  STRING_CSV()
    .andThen((stringCsv) => maybe.of(stringCsv[name]))
    .map((csv) => csv.split(','))
    .unwrapOr(defaultVal);

export const getNumberListConfig = (name: string, defaultVal: Array<number>) =>
  getFrontendConfigOverride('NumberCsv', name) ??
  NUMBER_CSV()
    .andThen((numberCsv) => maybe.of(numberCsv[name]))
    .map((csv) => csv.split(',').map(Number))
    .unwrapOr(defaultVal);
